module.exports = __webpack_public_path__ + "static/media/formation-icon.801e65ec.svg";